import React from "react";

export default function Xero() {
    return (
        <div>
            Xero App
        </div>
    )
}